import _ from 'lodash';

const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

const routes = [
  {
    path: 'orderCreate_develop',
    name: 'orderCreate_develop',
    meta: {
      title: '创建开发订单',
    },
    component: _import('orders/orderCreate.vue'),
  },
  {
    path: 'orderCreate_handle',
    name: 'orderCreate_handle',
    meta: {
      title: '创建订单',
    },
    component: _import('orders/orderCreate.vue'),
  },
  {
    path: 'createTurnOverOrder',
    name: 'createTurnOverOrder',
    meta: {
      title: '创建订单翻单',
    },
    component: _import('orders/createTurnOverOrder.vue'),
  },
  {
    path: 'customsDeclaration',
    name: 'customsDeclaration',
    meta: {
      title: '材料报关',
    },
    component: _import('orders/customsDeclaration.vue'),
  },
  {
    path: 'declareInfo/:id',
    name: 'declareInfo',
    meta: {
      title: '报关设置',
    },
    component: _import('orders/order/components/declareInfo/declareInfo.vue'),
  },
  {
    // 开发 转大货
    path: 'orderDevelopToHandle/:orderNum',
    name: 'orderDevelopToHandle',
    meta: {
      title: '开发转大货',
    },
    component: _import('orders/orderCreate.vue'),
  },
  {
    path: 'orderNewRollOver/:orderNum',
    name: 'orderNewRollOver',
    meta: {
      title: 'orderNewRollOver',
    },
    component: _import('orders/orderCreate.vue'),
  },
  {
    path: 'orders_handle',
    name: 'orders_handle',
    meta: {
      title: '订单列表',
    },
    component: _import('orders/Orders.vue'),
  },
  {
    path: 'orders_develop',
    name: 'orders_develop',
    meta: {
      title: '开发订单',
    },
    component: _import('orders/Orders.vue'),
  },
  {
    path: 'orderUsersManage/:orderNum',
    name: 'orderUsersManage',
    meta: {
      title: '订单人员管理',
    },
    component: _import('orders/order/orderUsersManage.vue'),
  },
  {
    path: 'order-budget-review-list',
    name: 'orderBudgetReviewList',
    meta: {
      title: '预算审批',
    },
    component: _import('orders/order/BudgetReviewList.vue'),
  },
  {
    path: 'order-budget-review-detail/:id',
    name: 'orderBudgetReviewDetail',
    meta: {
      title: '预算详情',
    },
    component: _import('orders/order/budgets/review/Index.vue'),
  },
  {
    path: 'verifyAccountsList',
    name: 'verifyAccountsList',
    meta: {
      title: '对账审批',
    },
    component: _import('orders/order/VerifyAccountsList.vue'),
  },
  {
    path: 'verifyAccountsDtl/:id',
    name: 'verifyAccountsDtl',
    meta: {
      title: '审批明细',
      radioGroup: 'verifyAccountsDtl',
    },
    component: _import('orders/order/VerifyAccountsDtl.vue'),
    children: _.map([
        {
          path: '',
          name: 'verifyAccountsDtl',
        },
        {
          path: 'Approval',
          name: 'verifyAccountsDtlApproval',
        },
      ], (r) => _.defaultsDeep(r, {
        name: r.path,
        meta: {
          radioGroup: 'verifyAccountsDtl',
          title: '审批明细',
        },
      }),
    ),
  },
  {
    path: ':num',
    name: 'orderDetail',
    meta: {
      title: '订单详情',
      radioGroup: 'orderDetail',
    },

    component: _import('orders/Order.vue'),
    children: _.map([
        {
          path: '',
          name: 'base',
          component: _import('orders/order/Base.vue'),
        },
        // {
        //   path: 'attachments',
        //   component: _import('orders/order/Attachments.vue'),
        // },
        {
          path: 'mix',
          component: _import('orders/order/Mix.vue'),
        }, {
          path: 'samplecheck',
          component: _import('orders/order/SampleList.vue'),
        }, {
          path: 'declareInfo',
          component: _import('orders/order/DeclareInfo.vue'),
        }, {
          path: 'costitems',
          component: _import('orders/order/costitem/OrderCostItems.vue'),
        }, {
          path: 'delivery',
          component: _import('orders/order/Delivery.vue'),
        },
        {
          path: 'deliveryCensus',
          component: _import('orders/order/DeliveryCensus.vue'),
        },
        //   {
        //   path: 'clothesDelivery',
        //   component: _import('orders/order/clothesdelivery/ClothesDelivery.vue'),
        // },
          {
          path: 'packing',
          component: _import('orders/order/Packing.vue'),
        },
        {
          path: 'process',
          component: _import('orders/order/Process.vue'),
        },
        {
          path: 'vendors',
          component: _import('orders/order/Vendors.vue'),
        },
        //   {
        //   path: 'chargeitems',
        //   component: _import('orders/order/chargeitem/OrderChargeItems.vue'),
        // },
      {
        path: 'profit',
        component: _import('orders/order/Profit.vue'),
      },
      {
        path: 'operationLog',
        component: _import('orders/order/OperationLog.vue'),
      },
      {
        path: 'contracts',
        component: _import('orders/order/Contracts.vue'),
      },{
        path: 'inventoryManage',
        component: _import('orders/order/inventory/orderInventoryManage.vue'),
      }
      ], (r) => _.defaultsDeep(r, {
        name: r.path,
        meta: {
          radioGroup: 'orderDetail',
          title: '订单详情',
        },
      }),
    ),
  },

];

const setDefaultMeta = (prefix) => (r) => {
  const newRoute = {
    ...r,
    path: `${prefix}${r.path}`,
    meta: _.defaults({
      auth: true,
    }, r.meta),
  };
  if (_.isArray(r.children) && !_.isEmpty(r.children)) {
    newRoute.children = _.map(r.children, setDefaultMeta(''));
  }
  return newRoute;
};

export default _.map(routes, setDefaultMeta('orders/'));
